<template>
  <div>
    {{ title }}
    <select v-model="selected">
      <option>All</option>
      <option v-for="item in zones">{{ item }}</option>
    </select>
  </div>
</template>
<script>
export default {
  props: ['title', 'query'],
  data() {
    return {
      selected: 'All',
      zones: []
    };
  },
  mounted() {
    this.zones = Sidekick.decode('sidekick.dmZones') || [];
  },
  watch: {
    selected(kw) {
      this.search();
    }
  },
  methods: {
    search() {
      const { query } = this;
      // `$props.query` would be initialized to `{ limit: 10, offset: 0, sort: '', order: '' }` by default
      // custom query conditions must be set to observable by using `Vue.set / $vm.$set`
      this.$set(query, 'zone', this.selected);
      query.offset = 0; // reset pagination
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/thZoneFilter.vue